import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'
import parse from 'html-react-parser'
import { GiFoodTruck } from 'react-icons/gi'
import { FiCheck } from 'react-icons/fi'
import { colors } from '../components/Colors'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import PageHeader from '../components/PageHeader'
import PageEye from '../components/PageEye'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  iframe {
    width: 100%;
    height: 460px;
    margin: 2em 0 1em;
    @media ${device.mobileL} {
      height: 260px;
    }
  }
  h3 {
    @media ${device.mobileL} {
      font-size: 22px;
    }
  }
  .intro {
    padding: 3em 2em;
    position: relative;
    background: ${colors.verdeGradiente};
    margin-top: 20px;
    h2 {
      font-weight: normal;
    }
    @media ${device.mobileL} {
      padding: 154px 2em 2em !important;
    }
    .image {
      position: absolute;
      display: block;
      right: 1px;
      width: 438px;
      z-index: 3;
      @media ${device.mobileL} {
        right: -10px;
        bottom: inherit;
        width: 272px;
        top: -197px;
      }
    }
    div {
      @media ${device.tablet} {
        width: 50%;
        font-weight: normal;
        font-size: 1em;
        margin-left: 5%;
      }
      @media ${device.mobileL} {
        width: 100%;
        font-weight: normal;
        font-size: 0.8em;
        margin-left: 0;
        box-sizing: border-box;
      }
    }
    .inner {
      border-bottom: 6px #ffffff solid;
      border-left: 6px #ffffff solid;
      border-right: 6px #ffffff solid;
      padding: 1em 2em;
      margin: 0 -90px;
      position: relative;
      min-height: 100px;
      display: flex;
      align-items: center;
      color: #ffffff;
      @media ${device.mobileL} {
        border: 6px #ffffff solid;
        display: block;
        padding: 2em 2em;
      }
      :before {
        content: '';
        background: #ffffff;
        width: 2%;
        height: 6px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        @media ${device.mobileL} {
          display: none;
        }
      }
      :after {
        content: '';
        background: #ffffff;
        width: 59%;
        height: 6px;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        @media ${device.mobileL} {
          display: none;
        }
      }
      h1 {
        font-size: 2em;
        position: absolute;
        top: -60px;
        left: 20px;
        padding: 0 0.5em;
        font-weight: normal;
        color: #ffffff;
        @media ${device.mobileL} {
          position: static;
          text-align: left;
          padding: 0;
        }
      }
      p {
        font-size: 1em;
        width: 100%;
        max-width: 560px;
        line-height: 1.6em;
        @media ${device.mobileL} {
          width: 100%;
          font-size: 1.5em;
          text-align: left;
        }
      }
      @media ${device.mobileL} {
        margin: 0;
        h2 {
          position: initial;
          text-align: left;
          padding: 0;
        }
      }
    }
  }
`

const GroupContent = styled.section`
  padding: 2em 0;

  @media ${device.mobileL} {
    padding: 2em;
    ul {
      margin: 0;
      padding: 0;
      li {
        text-align: left;
      }
    }
    h3 {
      text-align: left;
    }
  }
  .lista {
    h4 {
      margin-top: 4em;
    }
    ul {
      padding: 0;
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      li {
        margin: 0 1em 1em 0;
        padding: 0.8em 2em;
        list-style: none;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
        position: relative;
        min-height: 40px;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        align-items: center;

        @media ${device.mobileL} {
          width: 100%;
          padding: 0.8em 2em 1.2em 2em;
          margin: 0 0 2em 0;
          flex-wrap: wrap;
        }
        svg {
          font-size: 3em;
          padding: 0 0.5em 0 0;
          flex: none;
          color: ${colors.verde};
        }
      }
    }
  }
  .inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    .gatsby-image-wrapper {
      width: 40%;
      @media ${device.mobileL} {
        margin: 0;
        margin-bottom: 20px;
        height: auto;
        width: 100%;
        order: 1;
      }
    }
    div {
      width: 57.5%;
      @media ${device.mobileL} {
        width: 100%;
        order: 2;
        padding-bottom: 30px;
      }
    }
  }

  :nth-of-type(even) {
    h3 {
      color: #8e8fc7;
    }
  }
  :nth-of-type(3) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
    margin-bottom: 2em;
  }
  :nth-of-type(5) {
    background: ${colors.laranjaGradiente};
    color: #ffffff;
  }
  :nth-of-type(7) {
    background: ${colors.verdeGradiente};
    color: #ffffff;
    h3 {
      color: #fff8d1;
    }
  }
  li {
    padding-bottom: 10px;
    margin-bottom: 1em;
  }
`

const Alimentacao = styled.section`
  color: white;
  background: ${colors.laranjaGradiente};
  box-sizing: border-box;
  margin: 0 0 1em;
  padding: 2em;
  width: 100%;
  h3 {
    position: relative;
    color: #f4edc6;
    padding-left: 80px;
    @media ${device.mobileL} {
      padding-left: 0px;
      top: -5px;
    }
    svg {
      position: absolute;
      left: 0px;
      top: -20px;
      font-size: 0.7em;
      @media ${device.mobileL} {
        position: static;
        padding-right: 10px;
      }
    }
  }
  p {
    font-size: 0.9em;
  }
`
export const PorquesantajoanaTemplate = ({
  title,
  content,
  slug,
  color,
  image,
  sessoes,
  area = 'O Santa Joana',
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '/', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          bottom="-66px"
          overflow="visible"
          height="153px"
        />

        <GroupContent>
          <div className="lista center">
            <div>
              <h3>{parse(sessoes[0].tituloDaSessao)}</h3>
              <ul>
                {sessoes[0].listaDeItens.map((item, index) => (
                  <li key={index}>
                    <FiCheck />
                    {parse(item.item)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <div>
              <h3>{parse(sessoes[5].tituloDaSessao)}</h3>
              {parse(sessoes[5].texto)}
            </div>
          </div>
        </GroupContent>
        <PageEye
          title={sessoes[1].tituloDaSessao}
          content={sessoes[1].texto}
          image={sessoes[1].imagemDaSessao.sourceUrl}
          color="branco-lilas"
          height="363px"
          right="0"
          bottom="0"
          imgWidth="530px"
          overflow="visible"
        />
        <PageEye
          title={sessoes[2].tituloDaSessao}
          content={sessoes[2].texto}
          image={sessoes[2].imagemDaSessao.sourceUrl}
          color="laranjaReverso"
          height="294px"
          right="0"
          imgWidth="497px"
          bottom="0px"
        />
        <GroupContent>
          <div className="center">
            <h3>{parse(sessoes[3].tituloDaSessao)}</h3>
            <div className="inner">
              <div>{parse(sessoes[3].texto)}</div>
              {sessoes[3].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[3].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Segurança"
                />
              ) : (
                <img
                  src={sessoes[3].imagemDaSessao.sourceUrl}
                  alt="Segurança"
                />
              )}
            </div>
          </div>
        </GroupContent>
        <Alimentacao>
          <div className="center">
            <h3>
              <GiFoodTruck size="2.5em" />
              {parse(sessoes[4].tituloDaSessao)}
            </h3>
            {parse(sessoes[4].texto)}
          </div>
        </Alimentacao>
      </Container>
    </>
  )
}

PorquesantajoanaTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const porquesantajoana = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <PorquesantajoanaTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

porquesantajoana.propTypes = {
  data: PropTypes.object.isRequired,
}

export default porquesantajoana

export const porquesantajoanaQuery = graphql`
  query porquesantajoanaById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
